import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject, InjectionToken } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

const TABLET_BREAKPOINT =
  '(min-width: 600px) and (max-width: 839.98px) and (orientation: portrait), (min-width: 960px) and (max-width: 1199.98px) and (orientation: landscape)';
const WEB_BREAKPOINT =
  '(min-width: 840px) and (orientation: portrait), (min-width: 1200px) and (orientation: landscape)';

export const BREAKPOINTS = new InjectionToken('BREAKPOINTS', {
  factory: () => {
    const breakpoints = inject(BreakpointObserver);
    const observeBreakpoint = (breakpoint: string | string[]) =>
      toSignal(
        breakpoints
          .observe(Array.isArray(breakpoint) ? breakpoint : [breakpoint])
          .pipe(map((result) => result.matches)),
      );

    return {
      isHandset: observeBreakpoint(Breakpoints.Handset),
      isTablet: observeBreakpoint(TABLET_BREAKPOINT),
      isWeb: observeBreakpoint(WEB_BREAKPOINT),
    };
  },
});
